export const firebaseConfig = {
  apiKey: 'AIzaSyB4NQawRoqJTX8BdiYmrlnchDV8CN-VONQ',
  authDomain: 'stunning-base-164402.firebaseapp.com',
  databaseURL: 'https://stunning-base-164402.firebaseio.com',
  projectId: 'stunning-base-164402',
  storageBucket: 'stunning-base-164402.appspot.com',
  messagingSenderId: '211585366551',
  appId: '1:211585366551:web:e51060a8950b29ce'
};
